import { useContext } from "react";
import {
  setAccessToken,
  setIsLoggedIn,
  setUserId,
  setUserType,
  setCustomerInfo,
  setIsLoading,
} from "@actions/Auth";

import { getToken } from "@helpers/Auth";
import { AuthContext } from "@contexts/AuthProvider";
import { getCustomerInfo } from "@services/icm";

const getSessionContextDispatcher = (dispatch) => async () => {
  const { accessToken, isLoggedIn, userId, userType, loading } =
    await getToken();

  dispatch(setIsLoading(loading));
  dispatch(setAccessToken(accessToken));
  dispatch(setIsLoggedIn(isLoggedIn));
  dispatch(setUserId(userId));
  dispatch(setUserType(userType));

  if (isLoggedIn && accessToken) {
    const customerInfo = await getCustomerInfo(accessToken, userId);
    if (!customerInfo.error) {
      dispatch(setCustomerInfo(customerInfo));
    }
  }
};

const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }

  const [state, dispatch] = context;

  const getSessionContext = getSessionContextDispatcher(dispatch);

  return {
    getSessionContext,
    ...state,
  };
};

export default useAuth;
